<template>  
  <StationMonitor :tabs="['收益总览', '电价录入', '抄表结算', '电表读数','电价维护','远程电表','策略控制','策略模板','高级配置','天气数据']"/>
</template>

<script setup lang="ts">
import StationMonitor from '@/views/station-monitor/detail/index.vue'
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue'
const data = reactive({

})
</script>

